module.exports = __webpack_public_path__ + "img/_settings.8062c56b.svg";